import { actionTypes } from "./leaveReporingActions";

const {
  USER_LIST_PENDING,
  USER_LIST_SUCCESS,
  USER_LIST_ERROR,

  EMPLOYEE_LEAVE_LIST_PENDING,
  EMPLOYEE_LEAVE_LIST_SUCCESS,
  EMPLOYEE_LEAVE_LIST_ERROR,

  OTHER_SUMMARY_PENDING,
  OTHER_SUMMARY_SUCCESS,
  OTHER_SUMMARY_ERROR,

  EMPLOYEE_SUMMARY_PENDING,
  EMPLOYEE_SUMMARY_SUCCESS,
  EMPLOYEE_SUMMARY_ERROR,

  RESET_DATA,

  SET_FILTER,
  RESET_FILTER,
  OPTIONAL_HOLIDAY_LEAVE_SUMMARY_PENDING,
  OPTIONAL_HOLIDAY_LEAVE_SUMMARY_SUCCESS,
  OPTIONAL_HOLIDAY_LEAVE_SUMMARY_ERROR,

  HIDE_LEAVESUMMARY_SUCCESS,

  DATERANGE_LEAVELIST_PENDING,
  DATERANGE_LEAVELIST_SUCCESS,
  DATERANGE_LEAVELIST_ERROR,

  DOWNLOAD_LEAVE_REPORTING_LIST_PENDING,
  DOWNLOAD_LEAVE_REPORTING_LIST_SUCCESS,
  DOWNLOAD_LEAVE_REPORTING_LIST_ERROR,

  WFH_REPORTING_LIST_PENDING,
  WFH_REPORTING_LIST_SUCCESS,
  WFH_REPORTING_LIST_ERROR,

  DOWNLOAD_WFH_REPORTING_LIST_PENDING,
  DOWNLOAD_WFH_REPORTING_LIST_SUCCESS,
  DOWNLOAD_WFH_REPORTING_LIST_ERROR,

  SET_REPORTING_LIST_CATEGORY,
} = actionTypes;

const initialState = {
  userListPending: false,
  userListSuccess: false,
  userListError: null,

  employeeLeaveListPending: false,
  employeeLeaveListSuccess: false,
  employeeLeaveListError: null,

  otherLeavesSummaryPending: false,
  otherLeavesSummarySuccess: false,
  otherLeavesSummaryError: null,

  employeeLeavesSummaryPending: false,
  employeeLeavesSummarySuccess: false,
  employeeLeavesSummaryError: null,

  optionalHolidaySummaryPending: false,
  optionalHolidaySummarySuccess: false,
  optionalHolidaySummaryError: null,

  optionalHolidaySummary: null,

  showLoader: true,
  setShow: false,

  userList: [],

  employeeLeaveList: [],
  totalEmployeeLeaveList: [],
  currentYear: "",

  dateRangeLeaveListPending: false,
  dateRangeLeaveListSuccess: false,
  dateRangeLeaveListError: null,
  dateRangeLeaveList: [],
  startDate: "",
  endDate: "",

  // downloadLeaveReportingListPending: false,
  downloadLeaveReportingListSuccess: false,
  // downloadLeaveReportingListError: null,

  WFHReportingListPending: false,
  WFHReportingListSuccess: false,
  WFHReportingListError: null,

  // downloadWFHReportingListPending: false,
  downloadWFHReportingListSuccess: false,
  // downloadWFHReportingListError: null,

  employeeWFHList: [],
  employeeWFHUser: "",
  totalEmployeeWFHList: [],
  dateRangeWFHList: [],

  reportingListCategory: "",
};

export default function leaveReportingReducer(state = initialState, action) {
  const { type, payload } = action;
  // console.log("payload", payload);

  switch (type) {
    case USER_LIST_PENDING:
    case USER_LIST_ERROR:
    case USER_LIST_SUCCESS:
      return Object.assign({}, state, payload);
    case EMPLOYEE_LEAVE_LIST_PENDING:
    case EMPLOYEE_LEAVE_LIST_SUCCESS:
    case EMPLOYEE_LEAVE_LIST_ERROR:
      return Object.assign({}, state, payload);
    case EMPLOYEE_SUMMARY_PENDING:
    case EMPLOYEE_SUMMARY_SUCCESS:
    case EMPLOYEE_SUMMARY_ERROR:
      return Object.assign({}, state, payload);
    case OTHER_SUMMARY_PENDING:
    case OTHER_SUMMARY_SUCCESS:
    case OTHER_SUMMARY_ERROR:
      return Object.assign({}, state, payload);
    case RESET_DATA:
      return Object.assign({}, state, payload);
    case OPTIONAL_HOLIDAY_LEAVE_SUMMARY_PENDING:
    case OPTIONAL_HOLIDAY_LEAVE_SUMMARY_SUCCESS:
    case OPTIONAL_HOLIDAY_LEAVE_SUMMARY_ERROR:
      return Object.assign({}, state, payload);
    case RESET_FILTER:
      return Object.assign({}, state, {
        employeeLeaveList: state.totalEmployeeLeaveList,
        employeeWFHList: state.totalEmployeeWFHList,
      });
    case SET_FILTER:
      const { status, month } = payload.filterData;
      // console.log(status);
      // console.log(month);

      var newEmployeeList = [];
      const totalEmployeeList =
        state.reportingListCategory === "Leave"
          ? state.totalEmployeeLeaveList
          : state.reportingListCategory === "Work From Home"
          ? state.totalEmployeeWFHList
          : [];

      if ((status || status === 0) && month) {
        // console.log("hi");
        newEmployeeList = totalEmployeeList.filter(
          (list) =>
            list.status === status &&
            new Date(list.startDate).getMonth() + 1 === month
        );
      } else if (month) {
        newEmployeeList = totalEmployeeList.filter(
          (list) => new Date(list.startDate).getMonth() + 1 === month
        );
      } else if (status || status === 0) {
        newEmployeeList = totalEmployeeList.filter(
          (list) => list.status === status
        );
      }

      return state.reportingListCategory === "Leave"
        ? Object.assign({}, state, {
            employeeLeaveList: newEmployeeList,
          })
        : state.reportingListCategory === "Work From Home"
        ? Object.assign({}, state, {
            employeeWFHList: newEmployeeList,
          })
        : Object.assign({}, state, {
            employeeLeaveList: state.employeeLeaveList,
            employeeWFHList: state.employeeWFHList,
          });

    case HIDE_LEAVESUMMARY_SUCCESS:
      return Object.assign({}, state, payload);

    case DATERANGE_LEAVELIST_PENDING:
    case DATERANGE_LEAVELIST_SUCCESS:
    case DATERANGE_LEAVELIST_ERROR:
      return Object.assign({}, state, payload);

    case DOWNLOAD_LEAVE_REPORTING_LIST_PENDING:
    case DOWNLOAD_LEAVE_REPORTING_LIST_SUCCESS:
    case DOWNLOAD_LEAVE_REPORTING_LIST_ERROR:
      return Object.assign({}, state, payload);

    case WFH_REPORTING_LIST_PENDING:
    case WFH_REPORTING_LIST_SUCCESS:
    case WFH_REPORTING_LIST_ERROR:
      return Object.assign({}, state, payload);

    case DOWNLOAD_WFH_REPORTING_LIST_PENDING:
    case DOWNLOAD_WFH_REPORTING_LIST_SUCCESS:
    case DOWNLOAD_WFH_REPORTING_LIST_ERROR:
      return Object.assign({}, state, payload);

    case SET_REPORTING_LIST_CATEGORY:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
